import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ViewChildren, QueryList, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//components
import {FamilyTypeDropdownComponent} from '../../components/DomainData/FamilyTypeDropdown.component';
import {EquipmentGraphicsDropdownComponent} from '../../components/DomainData/EquipmentGraphicsDropdown.component';
import {EquipmentsAutoCompleteComponent} from '../../components/Equipment/EquipmentsAutoComplete.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-removaldetails',
  templateUrl: './RemovalDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => RemovalDetailsComponent)}]
})
export class RemovalDetailsComponent extends BaseControlGroupComponent {

    removalInfo: ent.RemovalInfo = new ent.RemovalInfo();
    
    removalDetailsForm: FormGroup;

    @Input() public requireEquipmentAssetNumber: boolean;
    @Input() public requireSerialNumber: boolean;
    @Input() public requireFamilyType: boolean;
    @Input() public requireModel: boolean;
    @Input() public requireEquipmentGraphics: boolean;
    @Input() public requireLocation: boolean;
    
    @ViewChild(FamilyTypeDropdownComponent) public familyTypeDropdownComponent: FamilyTypeDropdownComponent;
    @ViewChild(EquipmentGraphicsDropdownComponent) public equipmentGraphicsDropdown: EquipmentGraphicsDropdownComponent;
    @ViewChild(EquipmentsAutoCompleteComponent) public equipmentsAutoCompleteComponent: EquipmentsAutoCompleteComponent;

    setDates(){}

    setRequestInfo(request: ent.Request){
        this.removalInfo = request.RemovalInfo;

        if (this.equipmentsAutoCompleteComponent){
            this.equipmentsAutoCompleteComponent.equipments = [];
            this.equipmentsAutoCompleteComponent.selectedEquipmentNumbers = [];
            if (this.equipmentsAutoCompleteComponent.multiple){
                
            }
            else{
                // var filter: filters.EquipmentFilter = {EquipmentNumber: request.RemovalInfo.EquipmentAssetNumber};
                // this.equipmentService.getEquipments(filter).then(x=>
                // {
                //     if (x && x.length > 0){
                //         var equip = x[0];
                //         this.equipmentsAutoCompleteComponent.equipmentsModel = {name: equip.FullName, ID: equip.EquipmentNumber};
                //     }
                    
                // });
            }
        }
        
    }
    constructor(fb: FormBuilder, private equipmentService: serv.EquipmentService) 
    { 
        super();
        let group = {
          'equipmentAssetNumber' : '',
          'serialNumber' : '',
          'familyType' : '',
          'hidFamilyType' : '',
          'model' : '',
          'equipmentGraphics' : '',
          'hidEquipmentGraphics' : '',
          'location' : ''
        };
        
        this.removalDetailsForm = fb.group(group);

    }

    ngOnInit(): void {
        if(this.requireEquipmentAssetNumber) {
            this.removalDetailsForm.controls['equipmentAssetNumber'].setValidators(Validators.required);
        }  

        if(this.requireSerialNumber) {
            this.removalDetailsForm.controls['serialNumber'].setValidators(Validators.required);
        }  
      
        if(this.requireFamilyType) {
            this.removalDetailsForm.controls['familyType'].setValidators(dropDownValidator);
            this.removalDetailsForm.controls['hidFamilyType'].setValidators(hiddenDropDownValueValidator);
        }

        if(this.requireModel) {
            this.removalDetailsForm.controls['model'].setValidators(Validators.required);
        }

        if(this.requireEquipmentGraphics) {
            this.removalDetailsForm.controls['equipmentGraphics'].setValidators(dropDownValidator);
            this.removalDetailsForm.controls['hidEquipmentGraphics'].setValidators(hiddenDropDownValueValidator);
        }

        if(this.requireLocation) {
            this.removalDetailsForm.controls['location'].setValidators(Validators.required);
        }  
    }

    ngAfterViewInit() {

    }

    familyTypeSelected(){
        var val = true;
        var form = this.removalDetailsForm;
        if (form.controls.familyType.errors && form.controls.hidFamilyType.errors){
            if (form.controls.familyType.errors.invalid && form.controls.hidFamilyType.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    equipmentGraphicsSelected(){
        var val = true;
        var form = this.removalDetailsForm;
        if (form.controls.equipmentGraphics.errors && form.controls.hidEquipmentGraphics.errors){
            if (form.controls.equipmentGraphics.errors.invalid && form.controls.hidEquipmentGraphics.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    familyTypeChange(event: any){
        this.removalInfo.FamilyTypeID = event;
    }

    equipmentGraphicsChange(event: any){
        this.removalInfo.EquipmentGraphicsID = event;
    }

    selectedEquipmentNumbersChanged(equipmentNumbers: string[]){
        if (equipmentNumbers && equipmentNumbers.length > 0){
            // var filter: filters.EquipmentFilter = {EquipmentNumber: equipmentNumbers[equipmentNumbers.length - 1]};
            // this.equipmentService.getEquipments(filter).then(x=>
            // {
            //     if (x && x.length > 0){
            //         this.removalInfo.EquipmentAssetNumber = x[0].EquipmentNumber;
            //     }
            //     else{
            //         this.removalInfo.EquipmentAssetNumber = "";
            //     }
                
            // });
        }
        else{
            this.removalInfo.EquipmentAssetNumber = "";
        }

    }

}